import { Component, OnDestroy, OnInit } from '@angular/core';
import {
    SearchFormType,
    SeButtonsToolbarBase,
    SeButtonsToolbarService,
    RootState,
    seHeaderToolbarSetIsNavigateOnClickEnabled,
} from '@se/platform';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';

@Component({
    selector: 'toolupload-toolbar',
    templateUrl: './toolupload-toolbar.component.html',
    styleUrls: ['./toolupload-toolbar.component.scss']
})

export class TooluploadToolbarComponent extends SeButtonsToolbarBase implements OnInit, OnDestroy {

    constructor(
        actions: Actions,
        store: Store<RootState>,
        private buttonsToolbarService: SeButtonsToolbarService
    ) {
        super(actions, store);
    }
    ngOnDestroy(): void {
        this.store.dispatch(seHeaderToolbarSetIsNavigateOnClickEnabled({ enable: true }));
    }

    ngOnInit() {
        this.buttonsToolbarService.initSearchPageToolbar(SearchFormType.TOOLUPLOAD);
        this.store.dispatch(seHeaderToolbarSetIsNavigateOnClickEnabled({ enable: false }));
        this.isBackVisible = false;

    }
}
